export default {
    late: 'Late',
    past: 'Past',
    today: 'Today',
    upcoming: 'Upcoming',
};
